/**
* supervision detail management
*/
module.config(['$stateProvider', 'urls', function ($stateProvider, urls) {
    'use strict';
    $stateProvider
    	.state('member.supervision.detail.reception', {
            url: urls.member.supervision.reception.fr,
            views: {
                supervisionTitle: {
                    controller: ['$scope', '$filter', '$state', 'profile', function ($scope, $filter, $state, $profile) {
                        const back = $profile.authorization.rtq ? $state.href('member.rtq.list') : $state.href('member.supervision.list');

                        $scope.title = $filter('translate')('assessments.titleDetailIntern');
                        $scope.back = {
                            label: $filter('translate')('assessments.back'),
                            state: back
                        };
                    }],
                    templateUrl: 'src/views/member/assessments/member_supervision_title.html'
                },
                supervisionContent: {
                    controller: ['$q', '$scope', '$rootScope', '$filter', 'drupal', 'moment', '$state', '$stateParams', '$timeout', function ($q, $scope, $rootScope, $filter, $drupal, moment, $state, $stateParams, $timeout) {
                        var internshipId = $stateParams.id;
                        $scope.loading = true;

                        $scope.participants = [];

                        $drupal.getInterns(internshipId)
                            .then(function (interns) {
                                // $scope.internship = angular.copy(results[1][0]);
                                // store participants
                                $scope.participants = interns.map(function (participant) {
                                    participant.age = moment().diff(participant.birthdate, 'years');
                                    participant.show = false;
                                    $scope.checkPrerequisites(participant);
                                    return participant;
                                });

                                // release loading state
                                $scope.loading = false;
                            });

                        // show/hide detail handler
                        $scope.toggleDetail = function (participant) {
                            participant.show = !participant.show;
                            if (!participant.show && participant.cancel) {
                                participant.cancel.resolve();
                                participant.pending = false;
                            }
                        };

                        // refresh intern informations
                        $scope.refresh = function (participant) {
                            if (!participant.pending) {
                                participant.pending = true;
                                participant.cancel = $q.defer(); // store promise to cancel $http if detail is toggled hidden by user
                                $drupal.getIntern(participant.participationId, participant.cancel).then(function (results) {
                                    var remoteParticipant = results[0];
                                    // upgrade prerequisites flag
                                    $scope.checkPrerequisites(remoteParticipant)
                                    // update model and release pending state
                                    angular.merge(participant, remoteParticipant);
                                    participant.pending = false;
                                });
                            }
                        };

                        $scope.switch = function (participant, action) {
                            if (!participant[action + '_pending']) {
                                // add pending state
                                participant[action + '_pending'] = true;
                                // format data to send
                                var updated = {
                                    participationId: participant.participationId,
                                    contactId: participant.contactId
                                };
                                updated[action] = participant[action];
                                $drupal.updateIntern(internshipId, [updated]).catch(function (error) {
                                    // cancel model alteration
                                    $timeout(function() {
                                        participant[action] = !participant[action];
                                    }, 0);
                                }).finally(function () {
                                    // release pending state
                                   participant[action + '_pending'] = false;
                                });
                            }
                        };

                        $scope.checkPrerequisites = function (participant) {
                            // set prerequisites flag
                            participant.hasMedicalCertificatValidity = false;
                            participant.hasRecordJuniorValidity = false;
                            participant.hasPermissionAuthValidity = false;

                            participant.prerequisites.forEach(function (prerequisite) {
                                if (prerequisite.status !== 'Validé') {
                                    return;
                                }
                                if (prerequisite.documentType === 'Certificat médical') {
                                    participant.hasMedicalCertificatValidity = true;
                                } else if (prerequisite.documentType === 'Fiche de liaison') {
                                    participant.hasRecordJuniorValidity = true;
                                } else if (prerequisite.documentType === 'Autorisation de sortie de territoire') {
                                    participant.hasPermissionAuthValidity = true;
                                }
                            });
                        };

                    }],
                    templateUrl: 'src/views/member/assessments/member_supervision_reception.html'
                }
            }
        })
    	.state('member.supervision.detail.evaluations', {
            url: urls.member.supervision.evaluations.fr,
            views: {
                supervisionTitle: {
                    controller: ['$scope', '$filter', '$state', 'profile', function ($scope, $filter, $state, $profile) {
                        const back = $profile.authorization.rtq ? $state.href('member.rtq.list') : $state.href('member.supervision.list');

                        $scope.title = $filter('translate')('assessments.titleDetailIntern');
                        $scope.back = {
                            label: $filter('translate')('assessments.back'),
                            state: back
                        };
                    }],
                    templateUrl: 'src/views/member/assessments/member_supervision_title.html'
                },
                supervisionContent: {
                    controller: ['$q', '$scope', '$rootScope', '$filter', 'drupal', 'moment', '$state', '$stateParams', '$timeout', function ($q, $scope, $rootScope, $filter, $drupal, moment, $state, $stateParams, $timeout) {
                    	var internshipId = $stateParams.id;

                    	$scope.loading = true;
                    	$scope.buttons = [
                    		{ label: $filter('translate')('assessments.evaluate'), action: 'evaluate', css: 'alternate' },
                            { label: $filter('translate')('assessments.validate'), action: 'validate', css: 'deep' }
                    	];

                    	$scope.participants = [];

                        $drupal.getInterns(internshipId)
                            .then(function (interns) {
                                // $scope.internship = angular.copy(results[1][0]);
                                // store participants
                                $scope.participants = interns.map(function (participant) {
                                    participant.age = moment().diff(participant.birthdate, 'years');
                                    participant.show = false;
                                    return participant;
                                });

                                // release loading state
                                $scope.loading = false;
                            });


                        // event handler for internships button
                        $scope.actionList = function (action, participant) {
                            if (action === 'evaluate') {
                                $state.go('member.supervision.detail.evaluation', { participationId: participant.participationId });
                            } else if (action === 'validate') {
                                $state.go('member.supervision.detail.validation', { participationId: participant.participationId });
                            }
                        };
                    }],
                    templateUrl: 'src/views/member/assessments/member_supervision_evaluations.html'
                }
            }
        })
        .state('member.supervision.detail.evaluation', {
            url: urls.member.supervision.evaluation.fr + '/{participationId}',
            views: {
                supervisionTitle: {
                    controller: ['$scope', '$filter', '$state', function ($scope, $filter, $state) {
                        $scope.title = $filter('translate')('assessments.titleCompetencies');
                        $scope.back = {
                            label: $filter('translate')('assessments.backInterns'),
                            state: $state.href('member.supervision.detail.evaluations')
                        };
                    }],
                    templateUrl: 'src/views/member/assessments/member_supervision_title.html'
                },
                supervisionContent: {
                    controller: ['$q', '$scope', '$rootScope', 'lodash', '$filter', 'drupal', 'training', 'moment', '$state', '$stateParams', '$timeout', 'internshipdetail', function ($q, $scope, $rootScope, lodash, $filter, $drupal, $training, moment, $state, $stateParams, $timeout, $internshipdetail) {

                        var participationId = $stateParams.participationId;
                        $scope.loading = true;

                        $scope.labels = [
                            { text: $filter('translate')('trainings.acquiredNot'), value: 0 },
                            { text: $filter('translate')('trainings.acquiredPending'), value: 50 },
                            { text: $filter('translate')('trainings.acquiredDone'), value: 100 }
                        ];

                        $scope.contact = {};
                        $scope.competencies = [];
                        $scope.graduations = [];
                        $scope.updated = null;
                        $scope.displayFoil = ['Catamaran', 'Dériveur', 'Windsurf'].includes($internshipdetail.product.activity);

                        $scope.activePresentation = 'niveau';
                        $scope.changePresentation = function(){
                            $scope.loadingPresentation = true;

                            if( $scope.activePresentation === 'domaine' ){
                                $scope.activePresentation = 'niveau';
                            } else {
                                $scope.activePresentation = 'domaine';
                            }

                            if( $scope.activePresentation === 'domaine' ){
                                $drupal.getCompetencies(participationId, $internshipdetail.product.level.id, true).then(function(result) {
                                    if (!result || !result.participant) {
                                        return;
                                    }

                                    if (result.participation && result.participation.evaluated) {
                                        // already evaluated, should not display this page
                                        return swal({
                                            title: 'Accès refusé',
                                            text: 'Vous ne pouvez accéder à une évaluation déjà terminée.',
                                            type: 'warning'
                                        }).then(function () {
                                            return $state.go('member.supervision.detail.evaluations', {id: $internshipdetail.sfid, slug: $filter('slugify')($internshipdetail.product.name) });
                                        });
                                    }

                                    // process contact info & update
                                    angular.merge($scope.contact, result.participant); // TODO retrieve intern contact information
                                    // $scope.updated = new Date(result.updated);
                                    // $scope.graduations = result.achievement.sort(function (a, b) {
                                    //     return moment(b.obtainingDate).diff(moment(a.obtainingDate)) > 0;
                                    // });

                                    if (!result.competencies || result.competencies.length === 0 || !$internshipdetail.product || !$internshipdetail.product.level) {
                                        return;
                                    }
                                    // process evaluations
                                    //var currentLevel = $internshipdetail.product.level.value;
                                    var evaluations = result.competencies[0];
                                    var processedCompetencies = $training.upgradeCompetencies(evaluations, $scope.labels, $internshipdetail);
                                    var watchedValue = processedCompetencies.list;
                                    $scope.updated = processedCompetencies.updated;
                                    $scope.competencies = evaluations;

                                    // setup watchers
                                    watchedValue.forEach(function (watched) {
                                        $scope.$watch(function($scope) { return watched.value; }, function (current, previous) {
                                            if (current.acquis !== previous.acquis) {
                                                if (!current.pending) {
                                                    current.pending = true;
                                                    $drupal.updateCompetency({
                                                            internshipId: $scope.contact.sfid,
                                                            evaluationId: current.code,
                                                            evaluationValue: current.acquis
                                                        }).then(function () {
                                                            // update all completed counter
                                                            if (current.acquis === 100) {
                                                                $timeout(function () {
                                                                    watched.parentCategory.completed += 1;
                                                                    watched.parentSubCategory.completed += 1;
                                                                });
                                                            } else if (previous.acquis === 100) {
                                                                $timeout(function () {
                                                                    watched.parentCategory.completed -= 1;
                                                                    watched.parentSubCategory.completed -= 1;
                                                                });
                                                            }
                                                            // evaluation saved, set default value to updated one
                                                            current.evaluationValue = current.rating;
                                                            current.updated = true;
                                                            current.error = false;
                                                        }).catch(function (error) {
                                                            // reset evaluation form value to initial one
                                                            current.rating = current.evaluationValue;
                                                            current.error = true;
                                                            current.updated = false;
                                                            // TODO: error handling
                                                        }).finally(function () {
                                                            // use timeout to prevent watcher to loop
                                                            $timeout(function () { current.pending = false; }, 250);
                                                        });
                                                }
                                            }
                                        }, true);
                                    });
                                }).finally(function () {
                                    // release loading state
                                    $scope.loadingPresentation = false;
                                });
                            } else {
                                $drupal.getCompetenciesNiveau(participationId, $internshipdetail.product.level.id, true).then(function(result) {
                                    if (!result || !result.participant) {
                                        return;
                                    }

                                    if (result.participation && result.participation.evaluated) {
                                        // already evaluated, should not display this page
                                        return swal({
                                            title: 'Accès refusé',
                                            text: 'Vous ne pouvez accéder à une évaluation déjà terminée.',
                                            type: 'warning'
                                        }).then(function () {
                                            return $state.go('member.supervision.detail.evaluations', {id: $internshipdetail.sfid, slug: $filter('slugify')($internshipdetail.product.name) });
                                        });
                                    }

                                    // process contact info & update
                                    angular.merge($scope.contact, result.participant); // TODO retrieve intern contact information
                                    // $scope.updated = new Date(result.updated);
                                    // $scope.graduations = result.achievement.sort(function (a, b) {
                                    //     return moment(b.obtainingDate).diff(moment(a.obtainingDate)) > 0;
                                    // });

                                    if (!result.competencies || result.competencies.length === 0 || !$internshipdetail.product || !$internshipdetail.product.level) {
                                        return;
                                    }
                                    // process evaluations
                                    //var currentLevel = $internshipdetail.product.level.value;
                                    var evaluations = result.competencies[0];
                                    var processedCompetencies = $training.upgradeCompetenciesNiveau(evaluations, $scope.labels, $internshipdetail);
                                    var watchedValue = processedCompetencies.list;
                                    $scope.updated = processedCompetencies.updated;
                                    $scope.competencies = evaluations;

                                    // setup watchers
                                    watchedValue.forEach(function (watched) {
                                        $scope.$watch(function($scope) { return watched.value; }, function (current, previous) {
                                            if (current.acquis !== previous.acquis) {
                                                if (!current.pending) {
                                                    current.pending = true;
                                                    $drupal.updateCompetency({
                                                            internshipId: $scope.contact.sfid,
                                                            evaluationId: current.code,
                                                            evaluationValue: current.acquis
                                                        }).then(function () {
                                                            // update all completed counter
                                                            if (current.acquis === 100) {
                                                                $timeout(function () {
                                                                    watched.parentCategory.completed += 1;
                                                                    watched.parentSubCategory.completed += 1;
                                                                });
                                                            } else if (previous.acquis === 100) {
                                                                $timeout(function () {
                                                                    watched.parentCategory.completed -= 1;
                                                                    watched.parentSubCategory.completed -= 1;
                                                                });
                                                            }
                                                            // evaluation saved, set default value to updated one
                                                            current.evaluationValue = current.rating;
                                                        }).catch(function (error) {
                                                            // reset evaluation form value to initial one
                                                            current.rating = current.evaluationValue;
                                                            // TODO: error handling
                                                        }).finally(function () {
                                                            // use timeout to prevent watcher to loop
                                                            $timeout(function () { current.pending = false; }, 250);
                                                        });
                                                }
                                            }
                                        }, true);
                                    });
                                }).finally(function () {
                                    // release loading state
                                    $scope.loadingPresentation = false;
                                });
                            }
                        }

                        $drupal.getCompetenciesNiveau(participationId, $internshipdetail.product.level.id, true).then(function (result) {
                            if (!result || !result.participant) {
                                return;
                            }

                            if (result.participation && result.participation.evaluated) {
                                // already evaluated, should not display this page
                                return swal({
                                    title: 'Accès refusé',
                                    text: 'Vous ne pouvez accéder à une évaluation déjà terminée.',
                                    type: 'warning'
                                }).then(function () {
                                    return $state.go('member.supervision.detail.evaluations', {id: $internshipdetail.sfid, slug: $filter('slugify')($internshipdetail.product.name) });
                                });
                            }

                            // process contact info & update
                            angular.merge($scope.contact, result.participant); // TODO retrieve intern contact information
                            // $scope.updated = new Date(result.updated);
                            // $scope.graduations = result.achievement.sort(function (a, b) {
                            //     return moment(b.obtainingDate).diff(moment(a.obtainingDate)) > 0;
                            // });

                            if (!result.competencies || result.competencies.length === 0 || !$internshipdetail.product || !$internshipdetail.product.level) {
                                return;
                            }
                            // process evaluations
                            //var currentLevel = $internshipdetail.product.level.value;
                            var evaluations = result.competencies[0];
                            var processedCompetencies = $training.upgradeCompetenciesNiveau(evaluations, $scope.labels, $internshipdetail);
                            var watchedValue = processedCompetencies.list;
                            $scope.updated = processedCompetencies.updated;
                            $scope.competencies = evaluations;

                            // setup watchers
                            watchedValue.forEach(function (watched) {
                                $scope.$watch(function($scope) { return watched.value; }, function (current, previous) {
                                    if (current.acquis !== previous.acquis) {
                                        if (!current.pending) {
                                            current.pending = true;
                                            $drupal.updateCompetency({
                                                    internshipId: $scope.contact.sfid,
                                                    evaluationId: current.code,
                                                    evaluationValue: current.acquis
                                                }).then(function () {
                                                    // update all completed counter
                                                    if (current.acquis === 100) {
                                                        $timeout(function () {
                                                            watched.parentCategory.completed += 1;
                                                            watched.parentSubCategory.completed += 1;
                                                        });
                                                    } else if (previous.acquis === 100) {
                                                        $timeout(function () {
                                                            watched.parentCategory.completed -= 1;
                                                            watched.parentSubCategory.completed -= 1;
                                                        });
                                                    }
                                                    // evaluation saved, set default value to updated one
                                                    current.evaluationValue = current.rating;
                                                    current.updated = true;
                                                    current.error = false;
                                                }).catch(function (error) {
                                                    // reset evaluation form value to initial one
                                                    current.rating = current.evaluationValue;
                                                    current.error = true;
                                                    current.updated = false;
                                                    // TODO: error handling
                                                }).finally(function () {
                                                    // use timeout to prevent watcher to loop
                                                    $timeout(function () { current.pending = false; }, 250);
                                                });
                                        }
                                    }
                                }, true);
                            });
                        }).finally(function () {
                            // release loading state
                            $scope.loading = false;
                        });

                        $scope.confirm = function () {
                            if (!$scope.pending) {
                                $scope.pending = true;
                                swal({
                                    title: $filter('translate')('assessments.confirmEvaluationTitle'),
                                    text: ['(', $filter('translate')('assessments.confirmEvaluationSubtitle'), ')'].join(''),
                                    buttons: [$filter('translate')('form.cancel'), $filter('translate')('form.confirm')]
                                }).then(function (value) {
                                    if (value) {
                                        // confirmation by user, send data to sf
                                        return $drupal.finishEvaluation($scope.contact.sfid).then(function () {
                                            return swal({
                                                title: $filter('translate')('assessments.evaluationFinishOk'),
                                                text: '',
                                                type: 'info'
                                            }).then(function () {
                                                return $state.go('member.supervision.detail.evaluations', {id: $internshipdetail.sfid, slug: $filter('slugify')($internshipdetail.product.name) });
                                            });
                                        }).catch(function (error) {
                                            swal({
                                                title: 'Erreur interne',
                                                text: 'Une erreur interne est survenue lors de l\'enregistrement de votre évaluation. Merci de réessayer un peu plus tard.',
                                                type: 'error'
                                            });
                                        }).finally(function () {
                                            $timeout(function () { $scope.pending = false; });
                                        });
                                    } else {
                                        $timeout(function () { $scope.pending = false; });
                                    }
                                });
                            }
                        }

                        $scope.allLevelsOpened = false;

                        $scope.toggleAllLevels = function () {
                            $scope.allLevelsOpened = !$scope.allLevelsOpened;
                            if ($scope.competencies && $scope.competencies.niveau) {
                                $scope.competencies.niveau.forEach(function (level) {
                                    level.opened = $scope.allLevelsOpened;
                                    level.categories.forEach(function (category) {
                                        category.opened = $scope.allLevelsOpened;
                                        category.subcategories.forEach(function (subCategory) {
                                            subCategory.opened = $scope.allLevelsOpened;
                                        });
                                    });
                                });
                            }
                        };

                        $scope.allCategoriesOpened = false;

                        $scope.toggleAllCategories = function () {
                            $scope.allCategoriesOpened = !$scope.allCategoriesOpened;
                            if ($scope.competencies && $scope.competencies.categories) {
                                $scope.competencies.categories.forEach(function (category) {
                                    category.opened = $scope.allCategoriesOpened;
                                    category.subcategories.forEach(function (subCategory) {
                                        subCategory.opened = $scope.allCategoriesOpened;
                                    });
                                })
                            }
                        };

                        $scope.isAcquireSubCategoryDisabled = function (subCategory) {
                            if (subCategory.completed === subCategory.total) {
                                return true;
                            }
                            var allProcessing = true;
                            subCategory.competencies.forEach(function (competency) {
                                if (!competency.processing) {
                                    allProcessing = false;
                                }
                            });
                            return allProcessing;
                        };

                        $scope.isAcquireSubCategoryShown = function (subCategory) {
                            if (subCategory.competencies.length <= 1) {
                                return false;
                            }

                            var countShownCompetencies = 0;
                            subCategory.competencies.forEach(function (competency) {
                                if (!competency.caduc) {
                                    countShownCompetencies += 1;
                                }
                            });

                            return countShownCompetencies > 1;
                        }

                        $scope.acquireSubCategory = function(selectedSubCategory) {
                            var parentCategory = null;
                            var scopeSubCategory = null;
                            var parentNiveau = null;
                            // Récupération de la catégorie parente de la sous-catégorie cliquée
                            $scope.competencies.niveau.some(function (niveau) {
                                return niveau.categories.some(function (category) {
                                    return category.subcategories.some(function (subCategory) {
                                        // On arrête la boucle dès que la catégorie parente est trouvée
                                        if (subCategory.SD_code === selectedSubCategory.SD_code) {
                                            parentCategory = category;
                                            scopeSubCategory = subCategory;
                                            parentNiveau = niveau;
                                            return true;
                                        }
                                        return false;
                                    });
                                });
                            });

                            var competencies = scopeSubCategory.competencies;
                            competencies.forEach(function(competency) {
                                if (!competency.processing && competency.acquis !== 100) {
                                    competency.pending = true;
                                    $drupal.updateCompetency({
                                        internshipId: $scope.contact.sfid,
                                        evaluationId: competency.code,
                                        evaluationValue: 100
                                    }).then(function () {
                                        // update all completed counter
                                        competency.acquis = 100;
                                        parentCategory.completed += 1;
                                        scopeSubCategory.completed += 1;
                                        parentNiveau.completed += 1;
                                        competency.evaluationValue = competency.rating;
                                        competency.updated = true;
                                        competency.error = false;
                                    }).catch(function (error) {
                                        // reset evaluation form value to initial one
                                        competency.rating = competency.evaluationValue;
                                        competency.updated = false;
                                        competency.error = true;
                                        console.log(error);
                                    }).finally(function () {
                                        // use timeout to prevent watcher to loop
                                        $timeout(function () { competency.pending = false; }, 250);
                                    });
                                }
                            });
                        };
                    }],
                    templateUrl: 'src/views/member/assessments/member_supervision_evaluation.html'
                }
            }
        })
        .state('member.supervision.detail.validation', {
            url: urls.member.supervision.validation.fr + '/{participationId}',
            views: {
                supervisionTitle: {
                    controller: ['$scope', '$filter', '$state', function ($scope, $filter, $state, $internship) {
                        $scope.title = $filter('translate')('assessments.titleCompetenciesValidation');
                        $scope.back = {
                            label: $filter('translate')('assessments.backInterns'),
                            state: $state.href('member.supervision.detail.evaluations')
                        };
                    }],
                    templateUrl: 'src/views/member/assessments/member_supervision_title.html'
                },
                // Page Valider
                supervisionContent: {
                    controller: ['$q', '$scope', '$rootScope', 'lodash', '$filter', 'drupal', 'training', 'moment', '$state', '$stateParams', '$timeout', 'internshipdetail', function ($q, $scope, $rootScope, lodash, $filter, $drupal, $training, moment, $state, $stateParams, $timeout, $internship) {
                        var participationId = $stateParams.participationId;
                        $scope.loading = true;
                        $scope.validateAllLoading = false;

                        $scope.contact = {};
                        $scope.levels = [];
                        $scope.updated = null;

                        $scope.labels = [
                            { text: $filter('translate')('trainings.acquiredNot'), value: 'A évaluer' },
                            { text: $filter('translate')('trainings.acquiredPending'), value: 'Acquis partiel' },
                            { text: $filter('translate')('trainings.acquiredDone'), value: 'Acquis total' }
                        ];
                        $scope.ratings = {
                            '0': { value: 0, text: $filter('translate')('trainings.acquiredNot')},
                            '50': { value: 50, text: $filter('translate')('trainings.acquiredPending')},
                            '100': { value: 100, text: $filter('translate')('trainings.acquiredDone')}
                        };

                        $scope.options = [
                            { text: $filter('translate')('trainings.levelAquiredDone'), value: true },
                            { text: $filter('translate')('trainings.levelAquiredNot'), value: false }
                        ];

                        // preconisation form
                        $scope.preconisationForm = {};
                        $scope.preconisation = {
                            loading: true,
                            comment: '',
                            activity: null,
                            level: null
                        };
                        $scope.fields = {
                            pending: false,
                            loading: true,
                            updated: false,
                            changed: false,
                            activities: [],
                            levels: []
                        };

                        $scope.firstRender = true;

                        // retrieve activity & levels values
                        $drupal.getCriteria().then(function (criterias) {
                            const activityFilter = $rootScope.config.site.recommendations.branch;
                            if (activityFilter) {
                                $scope.fields.activity = criterias.filters.activity.options.filter(function (activity) {
                                    return activityFilter.includes(activity.name.toLowerCase().trim());
                                });
                            } else {
                                $scope.fields.activity = criterias.filters.activity.options;
                            }
                            const levelFilter = $rootScope.config.site.recommendations.levels;
                            if (levelFilter) {
                                $scope.fields.level = criterias.filters.level.options.filter(function (level) {
                                    return levelFilter.includes(level.label.toLowerCase().trim());
                                });
                            } else {
                                $scope.fields.level = criterias.filters.level.options;
                            }

                            // release subform loading state
                            $scope.fields.loading = false;
                        });

                        $drupal.getLevels(participationId, true).then(function (result) {
                            if (!result || !result.participant) {
                                return;
                            }
                            angular.merge($scope.contact, result.participant);
                            $scope.updated = new Date(result.participant.updated);

                            var selectLevel = null
                            result.competencies[0].levels.some(function(level) {
                                if(!level.N_obtenu) {
                                    selectLevel = level;
                                }

                                return !level.N_obtenu
                            })

                            angular.merge($scope.preconisation, {
                                loading: false,
                                activity: result.competencies[0].id || null,
                                level: selectLevel ? selectLevel.uuid : null,
                                comment: result.competencies[0].F_reco || ''
                            });

                            // $scope.graduations = result.achievement.sort(function (a, b) {
                            //     return moment(b.obtainingDate).diff(moment(a.obtainingDate)) > 0;
                            // });

                            if (!result.competencies || result.competencies.length === 0 || !$internship.product || !$internship.product.level) {
                                return;
                            }

                            var levels = result.competencies[0].levels;
                            $scope.levels = $training.upgradeLevels(levels, $internship.product.level.value, $scope.member.valideur_RTQ);
                            $scope.updated = result.participant.updated;

                        }).finally(function () {
                            $scope.loading = false;

                            $scope.getLevelsOfActivity();

                            $drupal.getPreconisation($scope.contact.sfid).then(function (result) {
                                $scope.preconisation.comment = result[0].comment;
                            });
                        });

                        $scope.getLevelsOfActivity = function () {
                            $drupal.getNiveaux($scope.preconisation.activity).then(function (result) {
                                if(!result) {
                                    return;
                                }
                                const levelFilter = $rootScope.config.site.recommendations.levels;
                                if (levelFilter) {
                                    result = result.filter(function (level) {
                                        return levelFilter.includes(level.label.toLowerCase().trim());
                                    });
                                }
                                $scope.fields.level = result;
                            }).finally(function() {
                                $scope.loading = false;
                                $scope.fields.loading = false;

                                if($scope.firstRender) {
                                    $scope.firstRender = false;
                                    $scope.fields.level.forEach(function(level) {

                                        if(level.name) {
                                            if(level.name.replace(' ', '') === $scope.preconisation.level) {
                                                $scope.preconisation.level = level.id;
                                            }
                                        }
                                    })
                                }
                            });
                        }

                        $scope.onInputChange = function() {
                            if (!$scope.fields.changed) {
                                $scope.fields.changed = true;
                            }
                            if ($scope.fields.updated) {
                                $scope.fields.updated = false;
                            }
                        }

                        // preconisation event handler
                        $scope.sendPreconisation = function (isvalid) {
                            if (isvalid && !$scope.fields.pending) {
                                $scope.fields.pending = true;
                                $drupal.updatePreconisation({
                                        internId: $scope.contact.sfid,
                                        adviceText: $scope.preconisation.comment,
                                        adviceFiliere: $scope.preconisation.activity,
                                        adviceLevel: $scope.preconisation.level
                                }).catch(function (error) {
                                        swal({
                                            title: 'Erreur interne',
                                            text: 'Une erreur interne est survenue lors de l\'enregistrement de votre préconisation. Merci de réessayer un peu plus tard.',
                                            type: 'error'
                                          });
                                    }).finally(function () {
                                        $scope.fields.pending = false;
                                        $scope.fields.updated = true;
                                        $scope.fields.changed = false;
                                    });
                            }
                        };

                        $scope.validateAllCompetencies = function(level) {
                            $scope.validateAllLoading = true
                            $drupal.validateAllCompetencies(level, $scope.contact.sfid).catch(function (error) {
                                swal({
                                    title: 'Erreur interne',
                                    text: 'Une erreur interne est survenue lors de l\'enregistrement de votre préconisation. Merci de réessayer un peu plus tard.',
                                    type: 'error'
                                });
                            }).finally(function (data) {
                                $scope.validateAllLoading = false
                                swal({
                                    title: 'Mise à jour en cours',
                                    text: 'La validation des compétences à bien été prise en compte.',
                                    type: 'success',
                                }).then(function() {
                                    location.reload();
                                });
                            });
                        }

                        // confirmation button handler
                        $scope.confirm = function (level) {
                            if (!level.pending) {
                                level.pending = true;
                                level.errors = false;
                                var mValid = { contactId: $scope.contact.sfid, levelUuid: level.uuid };

                                angular.merge(mValid, {
                                    validInstructor: level.confirmationInstructor,
                                    validRtq: level.confirmationRtq,
                                });

                                $drupal.confirmLevel(mValid).catch(function (error) {
                                    level.errors = true;
                                }).finally(function () {
                                    $timeout(function () {
                                        level.pending = false;
                                        if(!level.errors) {
                                            location.reload();
                                        }
                                    }, 250);
                                })
                            }
                        };
                    }],
                    templateUrl: 'src/views/member/assessments/member_supervision_validation.html'
                }
            }
        });
}]);
